Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
};

export function formatDate(times, pattern) {
  return new Date(times).Format(pattern || "yyyy-MM-dd hh:mm:ss").toLocaleString();
}

// 使用方法
// filters: {
//   formatDate: function (time) {
//     if (time != null && time !== '') {
//       const date = new Date(time)
//       return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
//     } else {
//       return ''
//     }
//   }
// },
